<template>
  <Head :title="`Dashboard - ${client.name}`" />
  
  <AppLayout>
    <div class="container-fluid">
      <div class="row justify-content-center mx-4">
        <div class="col p-0">
          <dashboard-layout :client="client" :user="user"></dashboard-layout>
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script setup>
import { Head } from '@inertiajs/vue3';
import AppLayout from '../Layouts/AppLayout.vue';
import { computed } from 'vue';

const props = defineProps({
  client: {
    type: Object,
    required: true
  },
  auth: {
    type: Object,
    required: true
  }
});

const user = computed(() => props.auth.user);
</script>

